import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { 
  Card, 
  Row,
  Table,
  Input,
  InputNumber,
  Form,
  DatePicker,
  Select,
  Popconfirm,
  Button,
  Icon,
  message,
  Alert 
} from 'antd';
import { EditableCell, EditableFormRow } from 'components/form/EditableCellTable.jsx';
import ModalTrasversalActivity from 'components/modal/ModalTrasversalActivity.jsx';

const FormItem = Form.Item;
const Textarea = Input.TextArea;
const Option = Select.Option;
const dateFormat = 'DD/MM/YYYY';

// TODO: inserire notificazione di antd e chiamate ajax
function createOptions(coll) {
  // console.warn('opts da passare: ', coll);
  if (coll && coll.length > 0) {
    return coll.map(formaDid => (
      <Option 
        key={formaDid.idFormaDidattica} 
        value={formaDid.idFormaDidattica}
      >{formaDid.descrizione}
      </Option>));
  }
  return;
}

// TODO: inserire notifiche di antd e gestione chiamate ajax
class TrasversalActivities extends React.Component {
  state = {
    argWidth: '300',
    columns: [
      {
        title: 'Attività didattica',
        dataIndex: 'idFormaDid',
        key: 'formaDid',
        disableClickOutsideHandler: true,
        editable: true,
        hasOptions: true,
        render: (data, row) => row.descFormaDid,
        createComponent: function(form,record,property,ref,onSave,opts) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <Select
                  ref={ref}
                  onSelect={onSave}
                >
                {opts}
                </Select>
              )}
            </FormItem>
          );
        },
      },
      {
        title: 'Descrizione',
        dataIndex: 'descrizione',
        key: 'descrizione',
        width: '25%',
        editable: true,
        createComponent: function(form,record,property,ref,onSave) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <Textarea rows={2}
                  ref={ref}
                  onPressEnter={onSave}
                  maxLength={2000}
                />
              )}
            </FormItem>
          );
        },
      },
      { 
        title: 'Altre Informazioni',
        dataIndex: 'altreInfo',
        key: 'altreInfo',
        width: '25%',
        editable: true,
        createComponent: function(form,record,property,ref,onSave) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <Textarea rows={2}
                  ref={ref}
                  onPressEnter={onSave}
                  maxLength={2000}
                />
              )}
            </FormItem>
          );
        },
      },
      {
        title: 'Data',
        dataIndex: 'data',
        key: 'date',
        width: '18%',
        render: data => { if (data !== undefined) return data.format(dateFormat) },
        editable: true,
        disableClickOutsideHandler: true,
        createComponent: (form,record,property,ref,onSave) => {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <DatePicker
                  ref={ref}
                  format={dateFormat}
                  onOpenChange={(status) => {
                    if (!status) {
                      onSave();
                    }
                  }}
                />
              )}
            </FormItem>
          );
        },
      },
      {
        title: 'Ore',
        dataIndex: 'ore',
        key: 'ore',
        width: '10%',
        editable: true,
        createComponent: function(form,record,property,ref,onSave) {
          return (
            <FormItem style={{ margin: 0 }}>
              {form.getFieldDecorator(property, {
                initialValue: record[property],
              })(
                <InputNumber
                  ref={ref}
                  step={0.5}
                />
              )}
            </FormItem>
          );
        },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '5%',
        render: (text, record) => (
          this.props.registryOccurrences.length >= 1 && this.props.registryInfo.stato === 'N'
            ? (
              <Popconfirm 
                title="Procedere con la cancellazione dell'attività?" 
                onConfirm={() => this.deleteRow(record)}
                okText="Sì"
                cancelText="No"
              >
                <Button type="danger">
                  <Icon type="delete" />
                </Button>
              </Popconfirm>
            ) : null
        ),
      }
    ]
  }

  updateRow = (row, cellName, cellValue) => {
    const occurrences = [];
    let retVal;
    const updatedRow = _.cloneDeep(row);
    console.warn('che riga ho:', row);
    updatedRow[cellName] = cellValue;
    occurrences.push(updatedRow);
    retVal = this.props.updateOccurrences(this.props.registryInfo.idRegistro, occurrences)
                  .then((response) => {
                    console.log('debug 8:', response);
                    if (response.error) {
                      return false;
                    }
                    console.log('debug 8: arrivato qua');
                    message.success('Modifica salvata con successo.');
                    return true;
                  });
    return retVal;
  }

  deleteRow = (record) => {
    console.warn('che riga devo cancellare?', record);
    // TODO: aggiungere chiamata ajax
    this.props.deleteOccurrences(this.props.registryInfo.idRegistro,record)
      .then((response) => {
        //TODO: handle notification
        console.warn(response);
        message.success('Cancellazione avvenuta correttamente.');
    });
  }

  render() {
    /* const columns = [
      {
        title: 'Attività didattica',
        dataIndex: 'idFormaDid',
        key: 'formaDid',
        render: (data, row) => row.descFormaDid,
      },
      {
        title: 'Descrizione',
        dataIndex: 'descrizione',
        key: 'descrizione',
      },
      { title: 'Altre Informazioni',
        dataIndex: 'altreInfo',
        key: 'altreInfo',
      },
      {
        title: 'Data',
        dataIndex: 'data',
        key: 'date',
        width: '13%',
//        render: data => data.format(dateFormat),
      },
      {
        title: 'Ore',
        dataIndex: 'ore',
        key: 'ore',
        width: '10%',
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '5%',
        render: (text, record) => (
          trasOccurrences.length >= 1 && this.props.registryInfo.stato === 'N'
            ? (
              <Popconfirm 
                title="Procedere con la cancellazione dell'attività?" 
                onConfirm={() => this.deleteRow(record)}
                okText="Sì"
                cancelText="No"
              >
                <Button type="danger">
                  <Icon type="delete" />
                </Button>
              </Popconfirm>
            ) : null
        ),
      }
    ]; */

    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const cols = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      if (col.hasOptions) {
        return {
          ...col,
          onCell: record => ({
            record,
            editable: col.editable,
            disableClickOutsideHandler: col.disableClickOutsideHandler,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSave: this.updateRow,
            createComponent: col.createComponent,
            hasOpts: createOptions(this.props.attivitaDid),
          }),
        };
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          disableClickOutsideHandler: col.disableClickOutsideHandler,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.updateRow,
          createComponent: col.createComponent,
        }),
      };
    });

    const annoAccademico = this.props.registryInfo.annoAccademico;
    const title = "Elenco Altre Attività Anno Accademico " + (annoAccademico-1) + "/" + annoAccademico;
    switch (this.props.registryInfo.stato) {
      case 'C':
      case 'A':
      case 'Z':
        return (
          <Card
            title={title}
            className="box box-solid box-unimi"
          >
            <Table
              rowKey="rId"
              className="registriTable"
              columns={this.state.columns}
              dataSource={this.props.registryOccurrences}
              pagination={false}
            />
          </Card>
        );
      case 'N':
      default:
        return (
          <Card
            title={title}
            className="box box-solid box-unimi"
          >
            <Alert
              message="Attenzione!"
              description="Il registro delle altre attivita NON deve essere compilato dai professori a contratto"
              type="warning"
              showIcon
              className="vmg10"
            />
            <Row className="vmg10">
              <ModalTrasversalActivity
                registryId={this.props.registryInfo.idRegistro}
                registryYear={this.props.registryInfo.annoAccademico}
                formeDidScheduled={this.props.attivitaDid}
                onSaveClick={this.props.onInsertActivity}
              />
            </Row>  
            <Table
              rowKey="rId"
              className="registriTable vmg10"
              components={components}
              columns={cols}
              dataSource={this.props.registryOccurrences}
              pagination={false}
            />
            <Row className="vmg10">
              <ModalTrasversalActivity
                registryId={this.props.registryInfo.idRegistro}
                registryYear={this.props.registryInfo.annoAccademico}
                formeDidScheduled={this.props.attivitaDid}
                onSaveClick={this.props.onInsertActivity}
              />
            </Row>  
          </Card>
        );
    }
  }
}

TrasversalActivities.propTypes = {
  registryInfo: PropTypes.object.isRequired,
  registryOccurrences: PropTypes.arrayOf(PropTypes.object).isRequired,
  attivitaDid: PropTypes.arrayOf(PropTypes.object),
  isLoaded: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  onInsertActivity: PropTypes.func.isRequired,
  deleteOccurrences: PropTypes.func.isRequired,
  updateOccurrences: PropTypes.func,
};

export { TrasversalActivities };
